import theme from '../theme';

export const boxShadow1 = ` 0 1px 4px rgba(0, 0, 0, 0.2), 0 0 40px rgba(0, 0, 0, 0.1)`;
export const boxShadow2 = `rgb(0 0 0 / 2%) 0px 1px 12px 0px, rgb(0 0 0 / 5%) 0px 0px 20px`;
export const whiteToOffWhiteGradient = `linear-gradient(${theme.colors.white} 90%, ${theme.colors.offWhiteSolid})`;
export const offWhiteToWhiteGradient = `linear-gradient(180deg, ${theme.colors.offWhiteSolid} 60%, ${theme.colors.white})`;
export const heroGradient1 = `linear-gradient(#F6F3EF 70%, #F6F3EF)`;
